<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :md="6" :sm="12">
            <a-form-item label="负责人">
              <a-input v-model="query.principal" placeholder="请输入负责人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="巡检泵房">
              <a-input v-model="query.pumpName" placeholder="请输入巡检泵房" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="任务名称">
              <a-input v-model="query.taskName" placeholder="请输入任务名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="下次巡检时间">
              <a-range-picker v-model="value3" @change="onChanget" style="width: 100%" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="margin-top: 12px">
          <a-col :span="24">
            <div class="table-page-search-submitButtons" >
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="PatrolAdd()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="editHandle(record)" v-action:edit>编辑</a>
        <a-divider type="vertical" /> -->
        <a @click="goDetails(record)">详情</a>
      </span>
      <span slot="planTime" slot-scope="text" v-if="text !== null">{{ text }} 天</span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
    </a-table>

    <patrol-modal ref="PatrolModal" @handleOk="queryList"></patrol-modal>
    <detail-modal ref="DetailModal"></detail-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import PatrolModal from './modules/PatrolModal'
import DetailModal from './modules/DetailModal'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '任务名称',
    dataIndex: 'taskName',
    ellipsis: true,
  },
  {
    title: '巡检泵房',
    dataIndex: 'pumpName',
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },

  {
    title: '巡检周期',
    dataIndex: 'inspectionFrequency',
  },
  {
    title: '任务描述',
    dataIndex: 'description',
    ellipsis: true,
  },
  {
    title: '上次巡检时间',
    dataIndex: 'lastInspectionDate',
  },
  {
    title: '下次巡检时间',
    dataIndex: 'nextInspectionDate',
  },
  {
    title: '预计处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },
  {
    title: '操作',
    width: 70,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    PatrolModal,
    DetailModal,
  },
  name: 'PatrolManagement',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/inspection_managements/page',
      deleteUrl: '/pipe-network/inspection_managements',
      addOrUpdateUrl: '/pipe-network/inspection_managements',
      queryOneUrl: '/pipe-network/inspection_managements',
      //   exportDataUrl: 'pipe-network/tenant_events/export',
      //   exportFileName: '事件管理表.xlsx',
      query: {
        startTime: '',
        endTime: '',
        principalName: '',
        sysType: '二次供水',
        pumpName: '',
        taskName: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
      },
      value3: [],
    }
  },
  filters: {},
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(_this.deleteUrl, { data: _this.selectedRows })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.selectedRows.length = ''
                console.log(_this.selectedRows.length, 'llll')
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          console.log(_this.selectedRows.length, 'lll')
          _this.$message.info('已取消删除')
        },
      })
    },
    // 重置
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.value3 = []
      this.queryList()
    },
    goDetails(record) {
      this.$refs.DetailModal.edit(record.id)
    },
    onChange(date, dateString) {
      this.query.endTime = dateString
    },
    onChanget(date, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    PatrolAdd() {
      this.$refs.PatrolModal.edit()
    },
    editHandle(record) {
      this.$refs.PatrolModal.edit(record.id)
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
 /deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
